import { render, staticRenderFns } from "./Member_identity.vue?vue&type=template&id=594f4595&scoped=true"
import script from "./Member_identity.vue?vue&type=script&lang=js"
export * from "./Member_identity.vue?vue&type=script&lang=js"
import style0 from "./Member_identity.vue?vue&type=style&index=0&id=594f4595&prod&scoped=true&lang=css"
import style1 from "./Member_identity.vue?vue&type=style&index=1&id=594f4595&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594f4595",
  null
  
)

export default component.exports